// extracted by mini-css-extract-plugin
export default {"root":"FavouriteListing_root__M3FBt","icon":"FavouriteListing_icon__iqgAn"};